





















































































































































































































































import { defineComponent, ref } from '@vue/composition-api';
import ViewContainer from '@/components/ViewContainer.vue';
import TextSection from '@/components/TextSection.vue';
import Modal from '@/components/Modal.vue';
import ParallaxContainer from '@/components/ParallaxContainer.vue';
import LaxContainer from '@/components/LaxContainer.vue';
import IvvScroller from '@/components/IvvScroller.vue';
import AudioPlayer from '@/prototyping/audio-player/Container.vue';
import Quiz from '../prototyping/quiz/Container.vue';

export default defineComponent({
  name: 'ProofOfConcept',
  components: {
    ViewContainer,
    TextSection,
    Modal,
    ParallaxContainer,
    LaxContainer,
    IvvScroller,
    GoogleModelViewer: () => import('@/components/GoogleModelViewer.vue'),
    BabylonViewer: () => import('@/components/BabylonViewer.vue'),
    Quiz,
    AudioPlayer,
  },
  setup() {
    return {
      isUnity: process.env.VUE_APP_TARGET === 'unity',
      showModal: ref(false),
      modelViewerLoadDH: ref(false),
      modelViewerLoadM: ref(false),
      modelViewerLoadB: ref(false),
      modelViewerLoadLS: ref(false),
      babylonLoadDH: ref(false),
      babylonLoadM: ref(false),
      babylonLoadB: ref(false),
      babylonLoadLS: ref(false),
    };
  },
});
